import TaxYearlyStatementSelectionScreen from 'features/statementsAndForms/screens/TaxStatements/TaxYearlyStatementSelectionScreen';
import React from 'react';

export default function TaxYearSelectionScreenPage() {
  return <TaxYearlyStatementSelectionScreen />;
}
